import {AsyncPipe, PercentPipe} from '@angular/common';
import {ChangeDetectionStrategy, Component} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {MIBFile, MIBReply, MIBReplyType} from '@emma-labs/shared/typescript';
import {CardModule} from 'primeng/card';
import {DropdownModule} from 'primeng/dropdown';
import {InputTextModule} from 'primeng/inputtext';
import {PaginatorModule} from 'primeng/paginator';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {UnderwritingProfileService} from '../../services/underwriting/underwriting-profile.service';
import {MainComponent} from '../main/main.component';
import {SkeletonComponent} from '../main/skeleton/skeleton.component';
import {CodedReportSectionComponent} from './coded-report-section/coded-report-section.component';
import {DetailsSectionComponent} from './details-section/details-section.component';
import {IAISectionComponent} from './iai-section/iai-section.component';

@Component({
  selector: 'em-underwriting-mib-page',
  templateUrl: './underwriting-mib-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MainComponent,
    AsyncPipe,
    CardModule,
    DropdownModule,
    InputTextModule,
    PaginatorModule,
    PercentPipe,
    DetailsSectionComponent,
    CodedReportSectionComponent,
    IAISectionComponent,
    SkeletonComponent,
  ],
})
export class UnderwritingMibPageComponent {
  data$: Observable<MIBFile>;

  constructor(
    readonly route: ActivatedRoute,
    readonly underwritingProfileService: UnderwritingProfileService,
  ) {
    if (!route.snapshot.params['underwritingProfileId']) {
      throw new Error('No underwriting profile id found');
    }

    this.data$ = underwritingProfileService.get(atob(route.snapshot.params['underwritingProfileId'])).pipe(
      map((underwritingProfile) => {
        if (underwritingProfile.mibFile) {
          return {
            mibReplies: underwritingProfile.mibFile.mibReplies?.sort((a, b) => {
              if (a.type === MIBReplyType.HIT && b.type !== MIBReplyType.HIT) return -1;
              if (a.type !== MIBReplyType.HIT && b.type === MIBReplyType.HIT) return 1;
              if (a.qualityMatchProbability === undefined) return 1;
              if (b.qualityMatchProbability === undefined) return -1;
              return b.qualityMatchProbability - a.qualityMatchProbability;
            }),
          };
        }
        return {};
      }),
    );
  }

  getFullName(reply: MIBReply) {
    const nameParts: string[] = [];

    if (reply.prefix) {
      nameParts.push(reply.prefix);
    }
    if (reply.firstName) {
      nameParts.push(reply.firstName);
    }
    if (reply.middleName) {
      nameParts.push(reply.middleName);
    }
    if (reply.lastName) {
      nameParts.push(reply.lastName);
    }

    let fullName = nameParts.join(' ');

    if (reply.suffix) {
      fullName += ', ' + reply.suffix;
    }

    return fullName.trim();
  }
}
